export default {
  controls: [
    {
      title: 'special.controls.hydraulic-controls',
      icon: 'icon-iboard',
      controlPanel: 'iboard'
    }
  ]
}
